import { render } from "./imgViewDialog.vue?vue&type=template&id=138fcd74&scoped=true"
import script from "./imgViewDialog.vue?vue&type=script&lang=js"
export * from "./imgViewDialog.vue?vue&type=script&lang=js"

import "./imgViewDialog.vue?vue&type=style&index=0&id=138fcd74&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138fcd74"]])

export default __exports__